module.exports = __webpack_public_path__ + "img/hannes_veskimae.c68c5d23.jpeg";